export default function(instance) {
	return {
		load_companies(params) {
			return instance({
				url: "/v4/companies/dispatcher/companies/autocomplete",
				method: "get",
				params,
			})
				.then(res => res.data.data)
				.catch(err => {
					throw err;
				});
		},
		load_houses_autocomplete(params) {
			return instance({
				url: "/v4/houses/dispatcher/houses/autocomplete",
				method: "get",
				params,
			})
				.then(res => res.data.data)
				.catch(err => {
					throw err;
				});
		},
	};
}
